import { Stack, Autocomplete, TextField } from "@mui/material";
import { useTranslations } from "next-intl";
import React from "react";

interface CustomTagComponentProps {
  inputValue?: string[];
  label: string;
  maxHeight: string | number;
  onTagValueChange: (value: string[]) => void;
}

export const CustomTagComponent = ({
  inputValue,
  label,
  onTagValueChange,
  maxHeight,
}: CustomTagComponentProps) => {
  const [tagValue, SetTagValue] = React.useState([]);
  const t = useTranslations();

  const handleOnTagValueChange = (input: string[]) => {
    SetTagValue(input);
    onTagValueChange(input);
  };

  React.useEffect(() => {
    if (inputValue && inputValue.length > 0) {
      SetTagValue(inputValue);
    }
  }, [inputValue]);

  return (
    <Stack id="CustomTagComponent">
      <Autocomplete
        multiple
        id="tag-filled-component"
        options={[]}
        onChange={(event, val: string[]) => handleOnTagValueChange(val)}
        freeSolo
        value={tagValue}
        renderInput={(params) => (
          <TextField
            {...params}
            label={t("labels." + label)}
            sx={{ maxHeight: maxHeight, overflow: "auto" }}
            placeholder={t("labels.typeTag")}
          />
        )}
      />
    </Stack>
  );
};

export default CustomTagComponent;
